import { Job } from 'sprockets_react/job_wizards/registries'
import $ from 'sprockets_react/job_wizards/jquery'

Job.Api = {
  post: function (url, data, cb) {
    $.ajax({
        url: window.SS.url + '/' + url,
        data: data,
        method: 'POST',
        headers: { 'Accept': 'application/vnd.api+json; version=3' },
        processData: false,
        contentType: 'application/json'
    })
    .always(cb)
    // TODO handle done and fail or perhpas promises???
  }
}
